import * as actions from "./actionsType";

const initialData = {
  loaderMetricNineBoxes: false,
  metricNineBoxes: null,
  metricNineBoxesAll: null,
  metricNineBoxesAnio: null,
  metricNineBoxesFalla: null,
  saveLoaderMetricNineBoxes: false,
  metricNineBoxesFormError: null,
};

export default function MetricNineBoxesReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_METRIC_NINE_BOXES:
      return { ...state, loaderMetricNineBoxes: action.payload };

    case actions.GET_METRIC_NINE_BOXES:
      return {
        ...state,
        metricNineBoxes: action.payload.metricNineBoxes,
        metricNineBoxesAll: action.payload.metricNineBoxesAll,
        metricNineBoxesAnio: action.payload.metricNineBoxesAnio
      };

    case actions.METRIC_NINE_BOXES_FALLA:
      return { ...state, metricNineBoxesFalla: action.payload };

    case actions.SAVE_LOADER_METRIC_NINE_BOXES:
      return { ...state, saveLoaderMetricNineBoxes: action.payload };

    case actions.FORM_METRIC_NINE_BOXES_FAIL:
      return { ...state, metricNineBoxesFormError: action.payload };

    default:
      return state;
  }
}